import { createGlobalStyle } from "styled-components";


const GlobalStyles = createGlobalStyle`
    body{
        font-family: Arial, Helvetica, sans-serif;
        margin: 0;
        color: #333;
    }
`
export default GlobalStyles